import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import reducers from '../reducers';
import thunkMiddleware from 'redux-thunk';

const loggerMiddleware = createLogger();

function reduxStore(initialState) {
  const store = createStore(
    reducers,
    initialState,
    applyMiddleware(
      thunkMiddleware, // lets us dispatch() functions
      loggerMiddleware // neat middleware that logs actions
    )
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      // We need to require for hot reloading to work properly.
      const nextReducer = require('../reducers');  // eslint-disable-line global-require

      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

export default reduxStore;



// WEBPACK FOOTER //
// ./stores/index.js